import axios from 'axios'
import {
  RatioCheckInOutDto,
  RatioOccupancyByBedDto,
  RatioOccupancyByCostumerDto,
  RatioRoomimngListDto,
  RatioSalesDetailDto,
  RatioSalesSummaryDto,
  ResponseOccupancyBed,
  ResponseOccupancyBedStatus,
  ResponseOccupancyByCustomer,
  ResponseRatio,
  ResponseRatioRoomingList,
  ResponseSalesDetail,
  ResponseSalesSummary,
} from '../models/reports.model'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export function getRatioCheckInOutService(dto: RatioCheckInOutDto) {
  return axios.post<ResponseRatio>(`${BASEURL}/ratios/getCheckInOut`, dto)
}

export function getRatioCheckInOutExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getCheckInOutDataExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioCheckInOutCSVService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getCheckInOutDataCSV`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/csv',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioCheckInOutPDFService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getCheckInOutDataPDF`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    },
    responseType: 'arraybuffer',
  })
}

//--

export function getRatioCheckInOutEmpExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getCheckInOutDataEmpExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioCheckInOutEmpCSVService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getCheckInOutDataEmpCSV`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/csv',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioCheckInOutEmpPDFService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getCheckInOutDataEmpPDF`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    },
    responseType: 'arraybuffer',
  })
}

// ===

export function getRatioCheckInOutCampExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getCheckInOutDataCampExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioCheckInOutCampCSVService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getCheckInOutDataCampCSV`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/csv',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioCheckInOutCampPDFService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getCheckInOutDataCampPDF`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    },
    responseType: 'arraybuffer',
  })
}

//--ROOMING LIST

export function getRatioRoomingListService(dto: RatioRoomimngListDto) {
  return axios.post<ResponseRatioRoomingList>(`${BASEURL}/ratios/getRooming`, dto)
}

export function getRatioRoomingListResumidoService(dto: any) {
  return axios.post<ResponseRatioRoomingList>(`${BASEURL}/ratios/getRooming_Resumido`, dto)
}

export function getRatioRoomingListResumidoExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getRooming_ResumidoExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioRoomingTotalesService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getRooming_Totales`, dto)
}

export function getRatioRoomingMainTotalesService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getRoomingMain_totales`, dto)
}

export function deleteReserveBedBatchService(data: any[]) {
  return axios.delete<any>(`${BASEURL}/ratios/deleteReserveBed_batch`, {
    data,
  })
}

export function getRatioRoomingListExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getRoomingExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioRoomingListCSVService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getRoomingCSV`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/csv',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioRoomingListPDFService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getRoomingPDF`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioRoomingListTotalExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getRoomingTotalExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioRoomingListTotalCSVService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getRoomingTotalCSV`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/csv',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioRoomingListTotalPDFService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getRoomingTotalPDF`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    },
    responseType: 'arraybuffer',
  })
}

// RESUMEN DE VENTAS

export function getRatioSalesSummaryService(dto: RatioSalesSummaryDto) {
  return axios.post<ResponseSalesSummary>(`${BASEURL}/ratios/getSalesSummary`, dto)
}

export function getRatioSalesSummaryExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getSalesSummaryExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioSalesSummaryCSVService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getSalesSummaryCSV`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/csv',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioSalesSummaryPDFService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getSalesSummaryPDF`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    },
    responseType: 'arraybuffer',
  })
}

// DETALLE DE VENTAS

export function getRatioSalesDetailService(dto: RatioSalesDetailDto) {
  return axios.post<ResponseSalesDetail>(`${BASEURL}/ratios/getSalesDetail`, dto)
}

export function getRatioSalesDetailExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getSalesDetailExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioSalesDetailCSVService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getSalesDetailCSV`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/csv',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioSalesDetailPDFService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getSalesDetailPDF`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    },
    responseType: 'arraybuffer',
  })
}

// OCCUPABILIDAD

export function getRatioOccupancyByCustomerService(dto: RatioOccupancyByCostumerDto) {
  return axios.post<ResponseOccupancyByCustomer>(`${BASEURL}/ratios/getOccupancyByCustomer`, dto)
}

export function getRatioSalesDeOccupancyByCustomerExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getOccupancyByCustomerExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioOccupancyByCustomerCSVService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getOccupancyByCustomerCSV`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/csv',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioOccupancyByCustomerPDFService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getOccupancyByCustomerPDF`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioOccupancyByBedStatusService(dto: RatioOccupancyByCostumerDto) {
  return axios.post<ResponseOccupancyBedStatus>(`${BASEURL}/ratios/getOccupancyByBedStatus`, dto)
}

export function getRatioSalesDeOccupancyByBedStatusExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getOccupancyByBedStatusExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioOccupancyByBedStatusCSVService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getOccupancyByBedStatusCSV`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/csv',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioOccupancyByBedStatusPDFService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getOccupancyByBedStatusPDF`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    },
    responseType: 'arraybuffer',
  })
}

//

export function getRatioOccupancyByBedService(dto: RatioOccupancyByBedDto) {
  return axios.post<ResponseOccupancyBed>(`${BASEURL}/ratios/getOccupancyByBed`, dto)
}

export function getRatioSalesDeOccupancyByBedExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getOccupancyByBedExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioOccupancyByBedCSVService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getOccupancyByBedCSV`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/csv',
    },
    responseType: 'arraybuffer',
  })
}

export function getRatioOccupancyByBedPDFService(dto: any) {
  return axios.post<any>(`${BASEURL}/ratios/getOccupancyByBedPDF`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    },
    responseType: 'arraybuffer',
  })
}

export function getAvailabilityEmployabilityExcelService(dto: any) {
  return axios.get<any>(`${BASEURL}/customReports/getAvailabilityEmployability`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
    params: dto,
  })
}

export function getSummaryStayExcelService(params: any) {
  return axios.get<any>(`${BASEURL}/customReports/getSummaryStay`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}
